namespace Matrix.DataAudit {
    export interface AccountHistoryGetDateMatchRequest extends Serenity.ServiceRequest {
        AccountCode?: string;
        StartDate?: string;
        EndDate?: string;
    }
}
